import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import Logo from "./svg/logo"
import { motion, AnimatePresence } from "framer-motion"
import { Slant as Hamburger } from 'hamburger-react'
import { OutboundLink } from "gatsby-plugin-google-analytics"


function Menu({ isOpen }) {
  const variants = {
    show: {
      opacity: 1,
      transition: { when: "beforeChildren", duration: 0.3 },
    },
    hide: {
      opacity: 0,
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.6,
        when: "afterChildren",
      },
    },
  }

  const childVariants = {
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
      },
    },
    hide: {
      opacity: 0,
      y: -10,
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: {
        duration: 0.4,
      },
    },
    toRight: {
      y: -5,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
  }
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          variants={variants}
          animate={isOpen ? "show" : "hide"}
          initial="hide"
          exit="exit"
          className="fixed top-0 left-0 right-0 bottom-0 w-full bg-white z-30"
        >
          <motion.div
            className="flex flex-column"
            variants={childVariants}
          >
            <div className="flex flex-col fs30 justify-center items-center mx-auto h-screen">
              <motion.div variants={childVariants} className="mb-2">
                <Link to="/" className="font-medium text-6xl">
                  Home
                </Link>
              </motion.div>
              <motion.div variants={childVariants} className="mb-2">
                <Link to="/blog" className="font-medium text-6xl">
                  Blog
                </Link>
              </motion.div>

              <motion.div variants={childVariants} className="mb-2">
                <Link to="/people" className="font-medium text-6xl">
                  People
                </Link>
              </motion.div>
              <motion.div variants={childVariants} className="mb-2">
                <Link to="/jobs" className="font-medium text-6xl">
                  Jobs
                </Link>
              </motion.div>
              <div className="mb-24"></div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default function Header({ isHome }) {
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden")
    } else {
      document.body.classList.remove("overflow-hidden")
    }
  }, [isOpen])
  return (
    <div
      className="bg-blue-white py-6"
    >
      <div className="max-w-6xl mx-auto flex items-center font-medium px-8 lg:px-8">
        <div className="mr-auto">
          <Link
            to="/"
            className=""
            aria-label="Bankjoy Logo"
          >
            <Logo width={120} />
          </Link>
        </div>
        <div className="hidden md:block">
          <Link
            to="/blog"
            className="mr-6 text-sm hoverBlue"
            activeClassName="circle"
          >
            Blog
          </Link>
          <Link
            to="/people"
            className="text-sm mr-6 hoverBlue"
            activeClassName="circle"
          >
            People
          </Link>
          <Link
            to="/jobs"
            className="text-sm mr-6 hoverBlue"
            activeClassName="circle"
          >
            Jobs
          </Link>
          <OutboundLink target="_blank" href="https://bankjoy.zendesk.com/hc/en-us/requests/new" className="hoverShadow text-xs rounded-full bg-blue text-white pb-2 pt-1.5 px-3">SUPPORT</OutboundLink>
        </div>
        <Menu isOpen={isOpen} />
        <button
          aria-label="Show menu"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="mt-1 md:hidden"
        >
          <div className={isOpen ? "z-50" : ""}>
            <Hamburger toggled={isOpen} toggle={setIsOpen} size={24}/>
          </div>
        </button>
      </div>
    </div>
  )
}
